export enum ActionTypes {
  ASYNC_START = 'at_a1',
  ASYNC_COMPLETE = 'at_a2',
  ASYNC_COMPLETE_WITH_SUCCESS = 'at_a3',
  ASYNC_COMPLETE_WITH_FAILURE = 'at_a4',
  ASYNC_SET = 'at_a5',
  RESET_STORE = 'at_a6',
  PAGE_LOADED = 'at_p1',
  PAGE_UNLOADED = 'at_p2',
  PAGE_PROPS_SENT = 'at_p3',
  USER_REGISTER = 'at_u1',
  USER_LOGIN = 'at_u2',
  USER_LOGOUT = 'at_u3',
}
